export default __webpack_public_path__ + "static/media/no.3728e32b.svg";